var Model = require("../types/Model.js");
var debounce = require("debounce");
var prop = require("prop");
var xtend = require("xtend");

module.exports = Model({
	name: "search",
	init: init,
	uninit: uninit,
	triggers: triggers,
	listeners: listeners,

	_blocked: null,
	_contacts: null,
	_searched: null,
	_request: null,

	recalculate: recalculate,
	update_search_results: update_search_results
});

// Keep track of which section should be displayed. Either "name" or "email"
// Have a trigger to set either one or the other

function init() {
	this._blocked = [];
	this._contacts = [];
	this._searched = [];
	this._request = [];
	this._section = [];
	this._denied = [];

	this.push({
		search: [],
		isEmail: false,
		section: "byName",
	});
}

function uninit() {
	this._blocked = null;
	this._contacts = null;
	this._searched = null;
	this._request = null;
	this._section = null;
	this._denied = null;
}

/**
 * Listen for updates to the lists of incoming and outgoing contact requests
 * @return {[type]} [description]
 */
function listeners() {
	return {
		"contacts:updated": handle_contacts_update,
		"blocking:updated": handle_blocking_update,
		"requests:updated": handle_requests_update
	};
}

function triggers() {
	return {
		"search": debounce(handle_trigger_search, 1000),
		"clear": clear_search,
		"section": handle_trigger_section,
	};
}

function recalculate() {
	var blockedIds = this._blocked;
	var contactIds = this._contacts.map(prop("_id"));
	var requestIds = this._request.map(prop("to._id"));

	var marked_search_results = this._searched.map(function (result) {
		var id = result._id;
		var isBlocked = blockedIds.indexOf(id) !== -1;
		var isContact = contactIds.indexOf(id) !== -1;
		var isRequest = requestIds.indexOf(id) !== -1;

		if (isBlocked)
			return xtend(result, {
				qualifier: "blocked"
			});

		if (isContact)
			return xtend(result, {
				qualifier: "existing"
			});

		if (isRequest)
			return xtend(result, {
				qualifier: "requested"
			});

		return result;
	});

	this.extend({
		search: marked_search_results
	});
}

/**
 * Creates a private variable with a list of the persons blocked by the user.
 * @param  {[type]} blocked [description]
 * @return {[type]}         [description]
 */
function handle_blocking_update(blocked) {
	this._blocked = blocked;

	this.recalculate();
}

/**
 * Creates a private variable holding a list of the user's contacts.
 * @param  {[type]} contacts [description]
 * @return {[type]}          [description]
 */
function handle_contacts_update(contacts) {
	this._contacts = contacts;

	this.recalculate();
}

function handle_requests_update(request) {
	this._request = request.outgoing;
	this.recalculate();
}

/**
 * Initiates a search and applies filters to it
 * @param  {Object} query Object with attributes: query (string), type (object)
 */
function handle_trigger_search(data) {
	var query = data.query;
	var filter = data.filter;
	this.api.people //execute the search
		.search(query, filter)
		.then(update_search_results.bind(this, query))
		.catch(console.error.bind(console))
		.then(updateQuery.bind(this, query));
	this.emit("usermetrics:trigger:track", "search people", {
		filter,
	});
}

function updateQuery(query) {
	var re = /^.+@([\w-]+\.)+[\w-]{2,4}$/;
	var isEmail = (query.match(re)) !== null;

	this.extend({
		query: query,
		isEmail: isEmail
	});
}

// Keep track of which section should be displayed. Either "name" or "email"
// Have a trigger to set either one or the other

function handle_trigger_section(data) {
	var section = data.name;
	this.extend({
		isEmail: false,
		section: section,
		search: [],
		query: ""
	});
}

/**
 * Pushes the search variable, updates the model data.
 * @param  {[type]} results [description]
 * @return {Array}         Array of objects that are the filtered search results.
 */
function update_search_results(query, results) {
	this._searched = results;

	this.recalculate();
}

/**
 * Clears the search results, important as it is called on page changes so that
 * the user always returns to a blank search after paging away.
 * @return {[type]} [description]
 */
function clear_search() {
	this._searched = [];
	this.push({
		search: [],
		section: "byName"
	});
}
